import { render, staticRenderFns } from "./BookmarksDialog.vue?vue&type=template&id=3ad90e76&scoped=true&"
import script from "@/components/bookmarks/BookmarksDialog/BookmarksDialog.ts?vue&type=script&lang=ts&"
export * from "@/components/bookmarks/BookmarksDialog/BookmarksDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/components/bookmarks/BookmarksDialog/bookmarks-dialog.scss?vue&type=style&index=0&id=3ad90e76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad90e76",
  null
  
)

export default component.exports